import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { KYMW1300Model } from '../kymw1300.model';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { MediumTypeModel } from "../vo/medium-type.model";

/**
 * 商品企画マスタ画面　媒体一覧を取得するサービス
 *
 * @export GetPlanGoodsMediumtService
 * @class GetPlanGoodsMediumtService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPlanGoodsMediumtService extends PlessJsonResponderSub<any> {

    /**
     * API成功時後続処理
     *
     * @private
     * @type {Function}
     * @memberof GetPlanGoodsMediumtService
     */
    private successFunc: Function = () => {};
    private model: any;

    constructor(
        protected plessHttp: PlessHttp,
        protected dialogService: PlessDialogServiceSub
    ) {
        super(plessHttp, dialogService);
    }

    /**
     * bodyにセットする値を返す
     *
     * @private
     * @returns {PlessRequest} リクエストJSON
     * @memberof GetPlanGoodsMediumtService
     */
    private getBody(): PlessRequest {
        return new PlessRequest();
    }

    /**
     * API呼び出し
     *
     * @param model
     * @param vo
     * @param {Function} successFunc 成功時後続処理
     * @memberof GetPlanGoodsMediumtService
     */
    execute(model: any, successFunc: Function = () => {}): void {
        this.model = model;
        this.successFunc = successFunc;
        this.send('getPlanGoodsMedium', this.getBody());
    }

    /**
     * API通信成功時の処理
     *
     * @param {*} data レスポンスデータ
     * @memberof GetPlanGoodsMediumtService
     */
    success(data: any): void {
        let tempDataList: MediumTypeModel[] = [];
        tempDataList = data;

        // 処理件数
        let index: number = <number>0;

        // 先頭空白追加
        const ob: MediumTypeModel = new MediumTypeModel();
        tempDataList.splice(index, 0, ob);
        index = 1;

        // コード+：+名称追加
        for (; index < tempDataList.length; index++) {
            tempDataList[index].MediumTypeName = tempDataList[index].MediumType + ':' + tempDataList[index].MediumName;
        }

        this.model.mediumTypeList = tempDataList;
        if (data) this.successFunc(data);
    }
}
